import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import FocusTrap from 'focus-trap-react';

export class ModalContent extends Component {
  render() {
    return ReactDOM.createPortal(
      <FocusTrap>
        <aside
          tag="aside"
          role="dialog"
          tabIndex="-1"
          aria-modal="true"
          className="modal page"
          onClick={this.props.onClickOutside}
          onKeyDown={this.props.onKeyDown}
        >
         <button
            ref={this.props.buttonRef}
            aria-label="Close Modal"
            aria-labelledby="close-modal"
            className="button button--close"
            onClick={this.props.closeModal}
         >
         </button>
          <div className="modal__wrap container" ref={this.props.modalRef}>
            <div className={`modal__body modal__body--${this.props.type} row page__constrain`}>
               {this.props.content}
            </div>
          </div>
        </aside>
      </FocusTrap>,
      document.body
    );
  }
}

export default ModalContent;